export enum palette {
  ERROR = "#ff7e94", // red
  PRIMARY = "#5C3F7F", // purple
  SECONDARY = "#f57c00", // orange
  SUCCESS = "#008187" // green
}
